import PropTypes from 'prop-types';
import { Map } from 'immutable';

export const propTypes = {
  expandSearchOptions: PropTypes.bool.isRequired,
  filter: PropTypes.instanceOf(Map),
};
